import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import FitGuideButton from "../fitGuideButton/FitGuideButton";
import { ProductData } from "../../types/productTypes/product";
import {
  fitTypeIdToTranslationKey,
  isFitGuideEligible,
} from "../../utils/fitGuideEligibility";

type RuntimeConstants = {
  product?: ProductData;
  webContext?: {
    browseLanguage?: string;
    browseCountry?: string;
    keyStoreDataversion?: string;
  };
  storeCode?: string;
  getTranslation?: (
    key: string,
    params?: Record<string, string>,
    locale?: string
  ) => string;
  fitGuideUrl?: string | null;
};

export default function FitGuideContainer() {
  const runtime = useRuntimeConstants() as RuntimeConstants;
  const brandId = runtime.product?.brandId ?? null;
  const productTypeId = runtime.product?.productType?.id ?? null;
  const gender = runtime.product?.gender ?? null;
  const fitType = runtime.product?.fitType ?? null;
  const browseLanguage = runtime.webContext?.browseLanguage;
  const browseCountry = runtime.webContext?.browseCountry;
  const keyStoreDataversion = runtime.webContext?.keyStoreDataversion;
  const storeCode = runtime.storeCode ?? "";
  const getTranslation = runtime.getTranslation ?? (() => "");
  const fitGuideUrl = runtime.fitGuideUrl ?? null;

  return isFitGuideEligible({
    brandId,
    productTypeId,
    gender,
    fitTypeId: fitType?.id ?? null,
    fitGuideUrl,
  }) ? (
    <>
      {". "}
      <FitGuideButton
        fitTypeId={fitType!.id}
        fitTypeCopyKey={fitTypeIdToTranslationKey[fitType!.id]}
        productTypeId={productTypeId!}
        brandId={brandId!}
        browseLanguage={browseLanguage}
        browseCountry={browseCountry}
        storeCode={storeCode}
        keyStoreDataVersion={keyStoreDataversion}
        gender={gender!}
        fitGuideUrl={fitGuideUrl!}
        getTranslation={getTranslation}
      />
    </>
  ) : null;
}
